import { Component } from '@verndale/core';
import { particlesJsCircle, particlesJsAbstract } from '../particles/particles';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      $particlesCircle: this.el.querySelector('#particles-js-circle'),
      $particlesAbstract: this.el.querySelector('#particles-js-rightbg'),
      $super: this.el.querySelectorAll('.super'),
      $image: this.el.querySelector('.super__img')
    };

    this.createParticles();
    this.checkAlignment();
  }

  checkAlignment() {
    if (this.dom.$super.length === 1 && this.dom.$image) {
      this.el.style = '--align-super: stretch';
    }
  }
  createParticles() {
    if (this.dom.$particlesCircle) {
      particlesJsCircle('particles-js-circle');
    }
    if (this.dom.$particlesAbstract) {
      particlesJsAbstract('particles-js-rightbg');
    }
  }
}

export default Module;
